import React from 'react';

const TransferenciaConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/transferencia',
      component: React.lazy(() => import('./Transferencia')),
    },
  ],
};

export default TransferenciaConfig;
